import { AuthenticationService } from '@openeducation/oe-it-services';

import { useEnvironmentContext } from '../environment/environment.provider';

export interface UseRecoverPasswordProps {
  onError: () => void;
  onSuccess: () => void;
}
export const useRecoverPassword = ({
  onError,
  onSuccess,
}: UseRecoverPasswordProps) => {
  const { environment } = useEnvironmentContext();

  const forgotPassword = async (username: string) => {
    try {
      await AuthenticationService.resetUserPassword(environment, username);
      onSuccess();
    } catch {
      onError();
    }
  };

  return {
    forgotPassword,
  };
};
